export const environment = {
    isProduction: false,
    clickkerWatcher: {
        api: {
            url: "https://api.watcher.clickker.eu/api"
        },
        webSocket: {
            url: "https://api.watcher.clickker.eu"
        }
    },
    clickkerCloud: {
        api: {
            url: "https://api.cloud.clickker.eu/api"
        },
        mvc: {
            url: "https://cloud.clickker.eu"
        }
    },
    clickkerAuth: {
        api: {
            url: "https://auth.clickker.eu"
        },
        login: {
            path: "authorization/login",
            clientId: "950ca3d4-6788-4799-bb5a-6fd6eef0b16e"
        },
        superTenantIds: [
            "08d9b999-3d0b-45f5-8154-ad9fb84cf707"
        ]
    }
};
